<div class="paywall-checkout__summary">
    <div (click)="goBack()" class="paywall-checkout__back">
        <span>Back</span>
    </div>
    <h2>{{ summaryTitle() }}</h2>
    <div class="paywall-checkout__lines">
      @for (charge of selectedPlan()?.charges ?? []; track charge.id ?? $index) {
        <div class="paywall-checkout__line">
          <span class="paywall-checkout__line-name">{{ charge.name }}</span>
          <span class="paywall-checkout__line-amount">{{ chargeLabel(charge) }}</span>
        </div>
      }
    </div>
    <div class="paywall-checkout__price">
        <span>{{ selectedPlan() | price:seats() }}</span>
    </div>
    <p class="paywall-checkout__period">{{ billingPeriodLabel() }}</p>
    @if (hasOneTime()) {
      <p class="paywall-checkout__one-time">{{ oneTimeLabel() }}</p>
    }
    @if (isQuantityPurchase()) {
      <div class="paywall-checkout__divider"></div>
      <p class="paywall-checkout__seats">{{ seatsLabel() }}</p>
      @for (charge of quantityChargeLines(); track charge.id ?? $index) {
        <p class="paywall-checkout__unit">{{ unitLabel(charge) }}</p>
      }
    }
</div>

<div class="paywall-checkout__form">

    <!-- Shared markup for a field's required marker and inline error. -->
    <ng-template #requiredMarker let-name>
        @if (isRequired(name)) {
        <span class="checkout__required" aria-hidden="true">*</span>
        }
    </ng-template>
    <ng-template #fieldErrorText let-name>
        @if (fieldError(name); as error) {
        <p class="checkout__field-error" [id]="name + '_error'">{{ error }}</p>
        }
    </ng-template>

    <form [formGroup]="checkoutForm" (ngSubmit)="submitForm()">
        <div class="checkout__form-group__left">
            @for (address of addressFields; track address.name) {
            <div class="checkout__form-group">
                <label [for]="address.name">
                    {{ address.label }}<ng-container *ngTemplateOutlet="requiredMarker; context: { $implicit: address.name }"></ng-container>
                </label>
                @if (address.name === 'country') {
                <select id="country" name="country" formControlName="country"
                    [attr.aria-invalid]="!!fieldError('country')" [attr.aria-describedby]="describedBy('country')">
                    @for(c of countries(); track c.id) {
                    <option value="{{c.id}}">{{c.name}}</option>
                    }
                </select>
                }
                @else {
                <input type="text" [id]="address.name" [name]="address.name" [formControlName]="address.name"
                    [attr.aria-invalid]="!!fieldError(address.name)"
                    [attr.aria-describedby]="describedBy(address.name)">
                }
                <ng-container *ngTemplateOutlet="fieldErrorText; context: { $implicit: address.name }"></ng-container>
            </div>
            }

            <!-- <yon-pw-autocomplete [itemsToSearch]="countries()"></yon-pw-autocomplete> -->

            <div style="margin-top: 16px;">
                @for(field of customFields; track field.id) {
                @if(field.fieldType === 2) {
                <div class="checkout__form-group__terms">
                    <input type="checkbox" id="{{field.id}}" name="{{field.id}}" formControlName="{{field.id}}"
                        [attr.aria-invalid]="!!fieldError(field.id)"
                        [attr.aria-describedby]="describedBy(field.id)">
                    <label for="{{field.id}}">
                        {{field.fieldDescription}}<ng-container *ngTemplateOutlet="requiredMarker; context: { $implicit: field.id }"></ng-container>
                    </label>
                </div>
                <ng-container *ngTemplateOutlet="fieldErrorText; context: { $implicit: field.id }"></ng-container>
                }
                @else {
                <div class="checkout__form-group">
                    <label for="{{field.id}}">
                        {{field.fieldDescription}}<ng-container *ngTemplateOutlet="requiredMarker; context: { $implicit: field.id }"></ng-container>
                    </label>
                    <input type="text" id="{{field.id}}" name="{{field.id}}" formControlName="{{field.id}}"
                        [attr.inputmode]="isIntegerField(field) ? 'numeric' : null"
                        [attr.aria-invalid]="!!fieldError(field.id)"
                        [attr.aria-describedby]="describedBy(field.id)">
                    <ng-container *ngTemplateOutlet="fieldErrorText; context: { $implicit: field.id }"></ng-container>
                </div>
                }
                }
            </div>
        </div>
        <div class="checkout__form-group__right">
            <div class="checkout__form-group-wrapper">
                <div class="checkout__form-group">
                    <label for="company_legal_name">
                        Company legal name<ng-container *ngTemplateOutlet="requiredMarker; context: { $implicit: 'company_legal_name' }"></ng-container>
                    </label>
                    <input type="text" id="company_legal_name" name="company_legal_name"
                        formControlName="company_legal_name"
                        [attr.aria-invalid]="!!fieldError('company_legal_name')"
                        [attr.aria-describedby]="describedBy('company_legal_name')">
                    <ng-container *ngTemplateOutlet="fieldErrorText; context: { $implicit: 'company_legal_name' }"></ng-container>
                </div>
                @if(paywallService.settings()?.checkoutFields?.organizationNumberEnabled) {
                <div class="checkout__form-group">
                    <label for="org_number">
                        Organization number<ng-container *ngTemplateOutlet="requiredMarker; context: { $implicit: 'org_number' }"></ng-container>
                    </label>
                    <input type="text" id="org_number" name="org_number" formControlName="org_number"
                        [attr.aria-invalid]="!!fieldError('org_number')"
                        [attr.aria-describedby]="describedBy('org_number')">
                    <ng-container *ngTemplateOutlet="fieldErrorText; context: { $implicit: 'org_number' }"></ng-container>
                </div>
                }
                @if(paywallService.settings()?.checkoutFields?.vatNumberEnabled) {
                <div class="checkout__form-group">
                    <label for="vat_number">
                        VAT number<ng-container *ngTemplateOutlet="requiredMarker; context: { $implicit: 'vat_number' }"></ng-container>
                    </label>
                    @if(viesValidationEnabled()) {
                    <div class="checkout__vat-input">
                        <input type="text" id="vat_number" name="vat_number" formControlName="vat_number"
                            [attr.aria-invalid]="!!fieldError('vat_number')"
                            [attr.aria-describedby]="describedBy('vat_number', vatStatusMessage() ? 'vat_status_tooltip' : null)">
                        @switch(vatStatus()) {
                        @case('checking') {
                        <span class="vat-status vat-status--checking" role="status" aria-label="Checking VAT number">
                            <span class="vat-status__spinner"></span>
                        </span>
                        }
                        @case('Valid') {
                        <span class="vat-status vat-status--valid" tabindex="0" role="img" aria-label="VAT number valid">
                            <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true">
                                <circle cx="10" cy="10" r="10" fill="currentColor" />
                                <path d="M5.5 10.5l3 3 6-6.5" fill="none" stroke="#FFF" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <span class="vat-status__tooltip" id="vat_status_tooltip" role="tooltip">{{ vatStatusMessage() }}</span>
                        </span>
                        }
                        @case('Invalid') {
                        <span class="vat-status vat-status--invalid" tabindex="0" role="img" aria-label="VAT number not valid">
                            <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true">
                                <circle cx="10" cy="10" r="10" fill="currentColor" />
                                <path d="M6.5 6.5l7 7M13.5 6.5l-7 7" fill="none" stroke="#FFF" stroke-width="2"
                                    stroke-linecap="round" />
                            </svg>
                            <span class="vat-status__tooltip" id="vat_status_tooltip" role="tooltip">{{ vatStatusMessage() }}</span>
                        </span>
                        }
                        @case('Unverifiable') {
                        <span class="vat-status vat-status--unverifiable" tabindex="0" role="img" aria-label="VAT number could not be verified">
                            <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true">
                                <circle cx="10" cy="10" r="10" fill="currentColor" />
                                <path d="M10 5.5v5.5" fill="none" stroke="#FFF" stroke-width="2" stroke-linecap="round" />
                                <circle cx="10" cy="14.25" r="1.25" fill="#FFF" />
                            </svg>
                            <span class="vat-status__tooltip" id="vat_status_tooltip" role="tooltip">{{ vatStatusMessage() }}</span>
                        </span>
                        }
                        }
                    </div>
                    }
                    @else {
                    <input type="text" id="vat_number" name="vat_number" formControlName="vat_number"
                        [attr.aria-invalid]="!!fieldError('vat_number')"
                        [attr.aria-describedby]="describedBy('vat_number')">
                    }
                    <ng-container *ngTemplateOutlet="fieldErrorText; context: { $implicit: 'vat_number' }"></ng-container>
                </div>
                }
                <div class="checkout__form-group">
                    <label for="email">
                        Billing email<ng-container *ngTemplateOutlet="requiredMarker; context: { $implicit: 'email' }"></ng-container>
                    </label>
                    <input type="text" id="email" name="email" formControlName="email" autocomplete="email"
                        [attr.aria-invalid]="!!fieldError('email')"
                        [attr.aria-describedby]="describedBy('email')">
                    <ng-container *ngTemplateOutlet="fieldErrorText; context: { $implicit: 'email' }"></ng-container>
                </div>
                <!-- <div class="checkout__form-group">
                    <label for="payment_method">Payment method</label>
                    <select id="payment_method" name="payment_method" formControlName="payment_method">
                        <option value="credit_card">Credit card</option>
                        <option value="invoice">Invoice</option>
                    </select>
                </div> -->
                @if (paywallService.settings()) {

                <div class="checkout__form-group__terms">
                    <input type="checkbox" id="terms_and_conditions" name="terms_and_conditions"
                        formControlName="terms_and_conditions"
                        [attr.aria-invalid]="!!fieldError('terms_and_conditions')"
                        [attr.aria-describedby]="describedBy('terms_and_conditions')">
                    <label for="terms_and_conditions">
                        I agree to the <a href="{{paywallService.settings()?.termsAndConditionLink}}"
                            target="_blank">terms and conditions</a>
                    </label>
                </div>
                <ng-container *ngTemplateOutlet="fieldErrorText; context: { $implicit: 'terms_and_conditions' }"></ng-container>
                }
            </div>

            @if(paywallService.purchaseBlockedReason()) {
            <div class="checkout__form-group__error">{{ paywallService.purchaseBlockedReason() }}</div>
            }
            @else if(paywallService.settings()?.testMode) {
            <div class="checkout__test-mode">Test mode: no card is charged. You will simulate the payment.</div>
            }

            <button [disabled]="purchaseInProgress() || !!paywallService.purchaseBlockedReason()" type="submit">
                @if(purchaseInProgress()) {
                <span>Processing...</span>
                <span class="loader"></span>
                }
                @else {
                <span>Buy now</span>
                }
            </button>

            @if(checkoutService.loadingState().error) {
            <div class="checkout__form-group__error checkout__purchase-error" role="alert">{{ checkoutService.loadingState().message }}</div>
            }
        </div>
    </form>
</div>